import { createOrderDetailsFulfillmentPlanPathname } from '../../../orders/order-details/routing';

export const generateOrderDetailsUrlFromSearchAndPath = (search, statePathName, fulfillmentPlanId, salesOrderId) => {
  const pathname = createOrderDetailsFulfillmentPlanPathname(statePathName, salesOrderId, fulfillmentPlanId);
  return `${pathname}${search || ''}`;
};
